import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::pdf
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:81
* @route '/profit-loss/export/pdf'
*/
export const pdf = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pdf.url(options),
    method: 'get',
})

pdf.definition = {
    methods: ["get","head"],
    url: '/profit-loss/export/pdf',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::pdf
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:81
* @route '/profit-loss/export/pdf'
*/
pdf.url = (options?: RouteQueryOptions) => {
    return pdf.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::pdf
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:81
* @route '/profit-loss/export/pdf'
*/
pdf.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pdf.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::pdf
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:81
* @route '/profit-loss/export/pdf'
*/
pdf.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pdf.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::pdf
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:81
* @route '/profit-loss/export/pdf'
*/
const pdfForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pdf.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::pdf
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:81
* @route '/profit-loss/export/pdf'
*/
pdfForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pdf.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::pdf
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:81
* @route '/profit-loss/export/pdf'
*/
pdfForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: pdf.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

pdf.form = pdfForm

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::excel
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:114
* @route '/profit-loss/export/excel'
*/
export const excel = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: excel.url(options),
    method: 'get',
})

excel.definition = {
    methods: ["get","head"],
    url: '/profit-loss/export/excel',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::excel
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:114
* @route '/profit-loss/export/excel'
*/
excel.url = (options?: RouteQueryOptions) => {
    return excel.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::excel
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:114
* @route '/profit-loss/export/excel'
*/
excel.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: excel.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::excel
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:114
* @route '/profit-loss/export/excel'
*/
excel.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: excel.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::excel
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:114
* @route '/profit-loss/export/excel'
*/
const excelForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: excel.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::excel
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:114
* @route '/profit-loss/export/excel'
*/
excelForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: excel.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::excel
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:114
* @route '/profit-loss/export/excel'
*/
excelForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: excel.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

excel.form = excelForm

const exportMethod = {
    pdf: Object.assign(pdf, pdf),
    excel: Object.assign(excel, excel),
}

export default exportMethod